import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Check, ArrowRight } from 'lucide-react';
import { usePhoneClick } from '../hooks/usePhoneClick';
interface CallCtaProps {
  title?: React.ReactNode;
  subtitle?: string;
}

/** Closing call-to-action used at the bottom of every page. */
export function CallCta({
  title = <>
      Ready for a{' '}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600" data-id="element-70" data-mp="3a21e1qtsedj3">
        Showroom Shine?
      </span>
    </>,
  subtitle = 'Book your mobile car detailing appointment today — serving Camarillo, Ventura, Thousand Oaks, Simi Valley and all of Ventura County'
}: CallCtaProps) {
  const {
    onClick,
    copied
  } = usePhoneClick();
  return <section className="w-full bg-gradient-to-b from-black to-zinc-950 py-20 px-4 border-t border-zinc-900" aria-labelledby="call-cta-heading" data-id="element-71" data-mp="3suwvznmmbr43">
      <div className="max-w-5xl mx-auto text-center" data-id="element-72" data-mp="1ygm7jg9xqyyu">
        <h2 id="call-cta-heading" className="text-3xl md:text-5xl font-black uppercase text-white mb-2" data-id="element-73" data-mp="1yhxchjf4acrj">
          {title}
        </h2>
        <p className="text-gray-400 text-lg mb-10" data-id="element-74" data-mp="x5nohnkkg9of">{subtitle}</p>

        <a href="tel:8183819905" onClick={onClick} className="group relative flex flex-col items-center justify-center w-full p-6 sm:p-8 md:p-12 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-colors duration-200 shadow-[0_0_40px_-10px_rgba(220,38,38,0.3)]" aria-label="Call or text Mike's Pro Detail at 818-381-9905" data-id="element-75" data-mp="x5xevc9iwiun">
          <span className="text-base sm:text-xl md:text-2xl text-gray-400 uppercase tracking-widest mb-2 font-bold" data-id="element-76" data-mp="1gt55q9jurgpm">
            Call or Text Mike
          </span>
          <span className="flex items-center gap-2 sm:gap-3 md:gap-6" data-id="element-77" data-mp="1kt5h1lbnnbsg">
            <Phone className="w-6 h-6 sm:w-8 sm:h-8 md:w-12 md:h-12 shrink-0 text-red-500 fill-red-500/20" aria-hidden="true" data-id="element-78" data-mp="1pt1lflo9l58j" />
            <span className="text-[28px] sm:text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-tighter whitespace-nowrap" data-id="element-79" data-mp="3moplbrvg140w">
              (818) 381-9905
            </span>
          </span>
          <span className="absolute -bottom-4 bg-black px-4 py-1 border border-zinc-800 rounded-full" data-id="element-80" data-mp="ytbwpy7zgb6w">
            <span className="text-green-500 font-bold uppercase text-sm flex items-center gap-2" data-id="element-81" data-mp="tuhf2zlr4sod">
              <span className="relative flex h-3 w-3" data-id="element-82" data-mp="17pjh3bnh9xvw">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-83" data-mp="12s1fy7fpcmyg" />
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-84" data-mp="1ho90j8v0vqe9" />
              </span>
              Available Now
            </span>
          </span>
        </a>

        <Link to="/contact" className="mt-12 inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-black hover:bg-gray-200 font-black text-lg uppercase tracking-wider rounded-sm transition-colors duration-150" data-id="element-85" data-mp="1qh3yrim2oluj">
          Get a Quote
          <ArrowRight className="w-5 h-5" aria-hidden="true" data-id="element-86" data-mp="1vhqiwqbz2x2p" />
        </Link>
      </div>

      {copied && <div role="status" className="fixed top-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg" data-id="element-87" data-mp="2f3jo38txwpuo">
          <Check className="w-5 h-5" aria-hidden="true" data-id="element-88" data-mp="2k1li2oswm9kx" />
          <span className="font-semibold" data-id="element-89" data-mp="255vredcrx89v">Phone number copied to clipboard!</span>
        </div>}
    </section>;
}